import { render, staticRenderFns } from "./ItemBadge.vue?vue&type=template&id=77a60908&"
import script from "./ItemBadge.vue?vue&type=script&lang=ts&"
export * from "./ItemBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports